import type { ReactNode } from "react";

/** A list whose rows each open a place (the queues of the home, what a search finds), in one bordered box. */
export function LinkList({ children }: { children: ReactNode }) {
  return <ul className="divide-y divide-border overflow-hidden rounded-lg border border-border">{children}</ul>;
}
